import { LucideIcon } from "lucide-react";
import { Button } from "./button";
import { ReactNode } from "react";

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description: string;
  actionLabel?: string;
  actionIcon?: LucideIcon;
  onAction?: () => void;
  children?: ReactNode;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  actionIcon: ActionIcon,
  onAction,
  children,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      {Icon && (
        <div className="mb-4 rounded-full bg-blue-50 p-3">
          <Icon className="h-6 w-6 text-blue-500" />
        </div>
      )}
      <h3 className="mb-2 text-lg font-medium">{title}</h3>
      <p className="max-w-md text-gray-500">{description}</p>
      {children}
      {actionLabel && onAction && (
        <Button className="mt-6 gap-2" onClick={onAction}>
          {ActionIcon && <ActionIcon className="h-4 w-4" />}
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
